module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<form>\n    <input name=\'site_tag[organization_id]\' type=\'hidden\' value=\'' +
((__t = ( WiseMetering.currentOrganization.id )) == null ? '' : __t) +
'\'>\n    <dl class=\'stepped zero\'>\n        <dt>\n            <label for=\'site_tag_name\'>' +
((__t = ( i18next.t('common.name') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <input class=\'text\' id=\'site_tag_name\' name=\'site_tag[name]\' type=\'text\'>\n        </dd>\n    </dl>\n</form>\n';

}
return __p
}